import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from '../Header';
import { fetchData, refreshAuthToken } from '../action';
import "../styles/theme.scss"
import { useTranslation } from 'react-i18next';
import { styled } from "@mui/material/styles";
import { Button, Grid, Typography } from "@mui/material";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import UploadIcon from "@mui/icons-material/Upload";
import PolicyHolderInsureeTab from "./PolicyHolderInsureeTab";
import { useNavigate } from "react-router-dom";
const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));
function InsureeContent() {
//   const navigate = useNavigate();
  const { t } = useTranslation();
 const navigate = (path) => {
    // Your custom navigation logic here
    // For example, you might use window.location.href to change the URL
    window.location.href = path;
  };
  const handleNavigation = (path) => {
    navigate(path);
  };
  return (
    <Grid>
      <Header
        navigate={handleNavigation}
        children={
          <Content>
            <PolicyHolderInsureeTab />
          </Content>
        }
      />
    </Grid>
  );
}

export default InsureeContent;
